import qs from 'qs';
import Vue from 'vue';

const entityName = 'Версии Приложения';
const serviceKey = 'appVersions';

const AppVersions = {
    namespaced: true,

    state: {
        items: [],
    },

    getters: {
        items(state) {
            return state.items;
        },
    },

    mutations: {
        setItems(state, { items }) {
            state['items'] = items;
        },

        setItem(state, { item, index }) {
            Vue.set(state['items'], index, item);
        },

        addItem(state, { item }) {
            state['items'].push(item);
        },
    },

    actions: {
        loadItems({ commit, dispatch, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});

                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': rootGetters['auth/getToken'],
                        'service': rootGetters.service[serviceKey],
                    }),
                }).then(response => (
                    commit('setItems', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', `Список '${entityName}' получен`),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', `Ошибка при получении списка '${entityName}'`),
                    reject(err);
                });
            })
        },

        save({ commit, dispatch, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': JSON.stringify(data.data),
                        'token': rootGetters['auth/getToken'],
                        'service': rootGetters.service[serviceKey],
                    }),
                }).then(response => {
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: response.data[0],
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root: true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные успешно отредактированы');
                    } else {
                        commit('addItem', {
                            item: response.data[0],
                        });
                        dispatch('loading/isLoading', false, {root: true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Запись создана');
                    }

                    resolve(response);
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных');
                    reject(err);
                });
            })
        },
    },
};

export default AppVersions;



// WEBPACK FOOTER //
// ./src/store/modules/appVersions.js